import React, { useState, useEffect } from "react";
import { formatToZMW, rootUrl, sumOfArray } from "../../../helpers";
import { useOutletContext } from "react-router-dom";
import { useAuth } from "../../../context/auth-context";

const CashBook = () => {
  const [allCash, setAllCash] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [openingBalance, setOpeningBalance] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const allData = useOutletContext();
    const auth = useAuth();

  const getOpeningBalance = (startDate) => {
    const data = allCash.filter(
      (item) => new Date(item.date.substring(0, 10)) < new Date(startDate)
    );

    
    

    const income = sumOfArray(
      data.filter((item) => item.type === "income").map((item) => parseFloat(item.amount))
    );
    const expense = sumOfArray(
      data.filter((item) => item.type === "expense").map((item) => parseFloat(item.amount))
    );
    return income - expense;
  };

  const displayTable = (data, bf) => {
    let totalCredits = 0;
    let totalDebits = 0;
    let balance = bf;

    const rows = data.map((obj) => {
      const debit = obj.type === "income" ? parseFloat(obj.amount) : 0;
      const credit = obj.type === "expense" ? parseFloat(obj.amount) : 0;
      totalCredits += credit;
      totalDebits += debit;
      balance += debit - credit;

      return (
        <tr key={obj.id}>
          <td className="px-4 py-2 border-b border-gray-300">{obj.date.substring(0, 10)}</td>
          <td className="px-4 py-2 border-b border-gray-300">
            {allData.bank.find((bank) => bank.id === obj.bank)?.name.substring(0, 2).toUpperCase() || ""}${obj.id}
          </td>
          <td className="px-4 py-2 border-b border-gray-300">{obj.cheque}</td>
          <td className="px-4 py-2 border-b border-gray-300">
            {(() => {
                if (obj.type === 'income') {
                const customer = allData?.customer?.find((a) => a.id === obj.paye);
                return customer ? `${customer.firstname} ${customer.lastname}` : 'N/A';
                } else {
                const supplier = allData?.suppliers?.find((a) => a.id === obj.paye);
                return supplier?.name || 'N/A';
                }
            })()}
            </td>

          <td className="px-4 py-2 border-b border-gray-300">{obj.description}</td>
          <td className="px-4 py-2 border-b border-gray-300">{formatToZMW(debit)}</td>
          <td className="px-4 py-2 border-b border-gray-300" >{formatToZMW(credit)}</td>
          <td className="px-4 py-2 border-b border-gray-300">{formatToZMW(balance)}</td>
        </tr>
      );
    });

    const totals = (
      <tr className="bg-blue-900 text-white">
        <th className="px-4 py-2 border-b border-gray-300" colSpan="5">Total</th>
        <th className="px-4 py-2 border-b border-gray-300">{formatToZMW(totalDebits)}</th>
        <th className="px-4 py-2 border-b border-gray-300">{formatToZMW(totalCredits)}</th>
        <th className="px-4 py-2 border-b border-gray-300">{formatToZMW(balance)}</th>
      </tr>
    );

    return (
      <>
        {rows}
        {totals}
      </>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(rootUrl(`/getCash/${auth.user.cid}`));
      const result = await response.json();
      console.log(result.data)
      const data = result.data || [];
      setAllCash(data);
      const currentDate = new Date();
      const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const bf = getOpeningBalance(firstDayOfMonth);
      const filtered = data.filter(
        (item) => new Date(item.date.substring(0, 10)) >= firstDayOfMonth
      );

      setOpeningBalance(bf);
      setFilteredData(filtered);
    };

    fetchData();
  }, []);

  const handleFilter = () => {
    const startDate = new Date(fromDate);
    const endDate = new Date(toDate);

    const bf = getOpeningBalance(startDate);
    const filtered = allCash.filter(
      (item) =>
        new Date(item.date.substring(0, 10)) >= startDate &&
        new Date(item.date.substring(0, 10)) <= endDate
    );

    setOpeningBalance(bf);
    setFilteredData(filtered);
  };

  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-between border-b pb-4">
        <div className="flex flex-col">
          <h4 className="text-[20px] text-slate-800 font-bold">Cash</h4>
        </div>
        <div className="flex items-center justify-end">
          <label htmlFor="from" className="text-[13px] text-slate-600 mr-2">
            From
          </label>
          <input
            type="date"
            id="from"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="w-[220px] from-date border rounded-md text-slate-700 px-3 h-[40px] outline-none text-[12px]"
            placeholder="From"
          />
          <label className="text-[12px] text-slate-600 mx-2">To</label>
          <input
            type="date"
            id="to"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="w-[220px] to-date rounded-md mr-2 text-slate-700 border px-2 h-[40px] outline-none text-[12px]"
            placeholder="To"
          />
          <button
            onClick={handleFilter}
            className="ml-2 px-4 py-2 bg-blue-500 text-white rounded-md"
          >
            Filter
          </button>
        </div>
      </div>

      <div className="w-full gl-table table mt-5 text-[13px] bg-slate-50 rounded-b-md" title="Cash Book">
        <div id="heading">
          <span className="font-bold mb-5">
            Opening balance: {formatToZMW(openingBalance)}
          </span>
        </div>
        <table className="table-auto w-full mt-4 border-collapse border border-gray-300 shadow-lg rounded-lg">
          <thead className="p-2">
            <tr className="bg-blue-900 text-white p-2">
              <th className="px-4 py-2 border-b border-gray-300">Date</th>
              <th className="px-4 py-2 border-b border-gray-300">Voucher</th>
              <th className="px-4 py-2 border-b border-gray-300">Cheque</th>
              <th className="px-4 py-2 border-b border-gray-300">Payee/Payer</th>
              <th className="px-4 py-2 border-b border-gray-300">Remarks</th>
              <th className="px-4 py-2 border-b border-gray-300">Debit</th>
              <th className="px-4 py-2 border-b border-gray-300">Credit</th>
              <th className="px-4 py-2 border-b border-gray-300">Balance</th>
            </tr>
          </thead>
          <tbody id="trows">{displayTable(filteredData, openingBalance)}</tbody>
        </table>
      </div>
    </div>
  );
};

export default CashBook;
